import Button from '@blocks/Button'
import Flex from '@blocks/Flex'
import Grid from '@blocks/Grid'
import MembershipController from '@club/customer/api/MembershipController'
import { route } from '@helpers'
import useAuth from '@hooks/useAuth'
import useStatic from '@hooks/useStatic'
import { colors } from '@styles/vars'
import React from 'react'
import { useParams } from 'react-router-dom'

export default function Guest({ club }: Props) {
    const auth = useAuth()
    const { secret } = useParams<{ secret: string }>()

    const accept = useStatic(async () => {
        const membership = await MembershipController.store(club.id, secret)
        auth.set('membership', membership)
    })

    return (
        <Grid gap="15px">
            <Grid columns="3">
                <Grid gap="10px">
                    <h1 className="h3">You're invited to {club.name}!</h1>
                    <p>It's the invitation link for to become a member of the group. If you want, you can accept the invitation.</p>
                </Grid>
            </Grid>
            <Grid columns="4">
                <Grid gap="5px">
                    <small>Email</small>
                    <p style={{ color: colors.black }}><b>{club.email}</b></p>
                </Grid>
                <Grid gap="5px">
                    <small>Head</small>
                    <p style={{ color: colors.black }}><b>{club.owner.first_name} {club.owner.last_name}</b></p>
                </Grid>
            </Grid>
            <Flex><Button width="auto" to={route("club:customer")} onClick={accept}>Accept the invitation</Button></Flex>
        </Grid>
    )
}

interface Props {
    club: Resources.ClubPartial
}